<template>
  <div>
    <div id="_div" class="w-100 px-5 py-4">
      <div id="Titulo_div">
        <h1>Reporte</h1>

      </div>
      <div style="display: flex">
        <div class="col-12 padding-div-low">
          <div class="area">
            <div class="row">
              <div class="col-6"><span>Periodo de Radicación</span></div>
              <div class="col-3"><span>Consecutivo</span></div>
              <div class="col-3"><span>Involucrados</span></div>
            </div>
            <div class="row" v-on:keyup.enter="getReporteQuejasAdministrativas">
              <div class="col-3"><input type="date" class="form-control" v-model="fechaInicialPeriodoRadicacion" /></div>
              <div class="col-3"><input type="date" class="form-control" v-model="fechaFinalPeriodoRadicacion" /></div>
              <div class="col-3"><input type="text" class="form-control" v-model="consecutivo" /></div>
              <div class="col-3"><input type="text" class="form-control" v-model="textoBusqueda" /></div>
            </div>
            <div class="row new-row">
              <div class="col-9"></div>
              <div class="col-3"><input type="button" class="form-control" value="Buscar" @click="getReporteQuejasAdministrativas" /></div>
            </div>
            <div class="row new-row">
              <div class="col-12">
                <table class="table table-striped table-light table-hover" id="tablaQuejasAdministrativas">
                  <thead class="thead-dark">
                    <tr>
                      <th class="col-1">No. QA</th>
                      <th class="col-2">Consecutivo</th>
                      <th class="col-5">Involucrados</th>
                      <th class="col-3">Fecha de Radicación</th>
                      <th class="col-1">Acciones</th>
                    </tr>
                  </thead>
                  <tbody class="text-dark">
                    <tr v-for="(queja, indice) in quejasAdministrativas">
                      <td>{{queja.quejaAdministrativaId}}</td>
                      <td>{{queja.consecutivo}}</td>
                      <td v-html="mostrarInvolucradosQuejaAdministrativa(queja)"></td>
                      <td>{{new Date(queja.fechaDeRadicacion).toLocaleDateString('es-MX', opcionesFechaLocal)}}</td>                      
                      <td>
                        <i class="fas fa-gavel fa-2x" title="Capturar Datos de la Sentencia" @click="abrirModalCapturaDatosSentencia(queja.quejaAdministrativaId)" />
                      </td>
                    </tr>
                    <tr v-if="quejasAdministrativas.length == 0"><td colspan="2">No se encontraron quejas administrativas.</td></tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <ModalCapturaDatosSentencia
                                    :quejaAdministrativaId ="parametrosModalCapturaDatosSentencia.quejaAdministrativaId"
                                    v-on:valorParaElPadre="quitarQuejaEditada">
        </ModalCapturaDatosSentencia>
      </div>
      
    </div>
  </div>
</template>
<script>

  import catalogos from '@/../static/js/catalogos'
  import axios from 'axios';
  import api from '@/../static/js/api';
  import comun from '@/../static/js/comun';
  import store from '@/store/index'
  import enumeraciones from '@/../static/js/enumeraciones'
  import ModalCapturaDatosSentencia from '@/components/SIQA/QuejasAdministrativas/QuejasPendientes/ModalCapturaDatosSentencia.vue'
  export default {
    data() {
      return {
        enumeraciones,
        catalogos,
        fechaInicialPeriodoRadicacion: null,
        fechaFinalPeriodoRadicacion: null,
        consecutivo: "",
        textoBusqueda: "",
        quejasAdministrativas: [],
        opcionesFechaLocal: { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' },
        parametrosModalCapturaDatosSentencia: {quejaAdministrativaId: -1 }
      }
    },
    props: {
    },
    mounted() {
      this.getReporteQuejasAdministrativas();
    },
    components: {
      C003TiposDeSentidoDeSentencia: catalogos.SIQA.C003TiposDeSentidoDeSentencia,
      ModalCapturaDatosSentencia
    },
    methods: {
      getReporteQuejasAdministrativas: function () { //Retorna una lista de citas 'Aceptadas'
        var peticion = {
          "fechaInicialPeriodoRadicacion": this.fechaInicialPeriodoRadicacion,
          "fechaFinalPeriodoRadicacion": this.fechaFinalPeriodoRadicacion,
          "fechaInicialPeriodoSentencia": null,
          "fechaFinalPeriodoSentencia": null,
          "consecutivo": this.consecutivo,
          "tipoDeSentidoDeSentenciaId": 8,
          "textoBusqueda": this.textoBusqueda
        };
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SIQA.funciones.GetReporteQuejasAdministrativas, peticion, comun.CrearElHeaderDeAutorizacion(store.state.Login_AutorizacionOriginal)).then(response => {
          comun.SeEstaCargandoInformacion(true);
          if (response.data.SiHayError == false) {//En caso de que la petición sea exitosa
            this.quejasAdministrativas = response.data.quejasAdministrativas;
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          comun.SeEstaCargandoInformacion(false);
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
          comun.SeEstaCargandoInformacion(false);
        });
      },
      mostrarInvolucradosQuejaAdministrativa(quejaAdministrativa) {
        let listaQuejosos = quejaAdministrativa.quejaAdministrativa_involucrados.filter(qa_inv => qa_inv.tipoDeInvolucradoId === 1).map(qa_inv => qa_inv.involucrado)
          .map(involucrado => `<li>${this.obtenerNombreCompleto(involucrado.nombre, involucrado.apellidoPaterno, involucrado.apellidoMaterno)}</li>`).join('');
        let listaDemandados = quejaAdministrativa.quejaAdministrativa_involucrados.filter(qa_inv => qa_inv.tipoDeInvolucradoId === 2).map(qa_inv => qa_inv.involucrado)
          .map(involucrado => `<li>${this.obtenerNombreCompleto(involucrado.nombre, involucrado.apellidoPaterno, involucrado.apellidoMaterno)} : <b>${involucrado.cargo}</b></li>`).join('');
        let listaFinal = `<span>Quejosos</span><ul>${listaQuejosos}</ul><span>Demandados</span><ul>${listaDemandados}</ul>`
        //quejosos =
        return listaFinal;
      },
      obtenerNombreCompleto(nombre, apellidoPaterno, apellidoMaterno) {
        return [nombre, apellidoPaterno, apellidoMaterno].filter(palabra => palabra.length > 0).join(' ');
      },
      abrirModalCapturaDatosSentencia(quejaAdministrativaId) {
        this.parametrosModalCapturaDatosSentencia.quejaAdministrativaId = quejaAdministrativaId;
        $('#modalCapturarDatosSentencia').modal('toggle');
      },
      quitarQuejaEditada(datos) { //Administra los cambios en el componente de Área
        catalogos
        console.log(datos)
        this.quejasAdministrativas = this.quejasAdministrativas.filter(qa => qa.quejaAdministrativaId !== datos);
      }

    },
    created() {

    }
  }
</script>

<style scoped>


  .padding-div-low {
    padding-top: 40px;
  }

  .fas {
    cursor: pointer;
  }

  .new-row {
    margin-top: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/SIQA/QuejasAdministrativas/QuejasPendientes/QuejasPendientes.vue